/**
 * Shared Recharts styling.
 *
 * Extracted from FinancePortfolioPage so the Sprint 14 Overview/P&L charts
 * read as the same system rather than each page inventing its own palette.
 */

export const CHART_TOOLTIP_STYLE = {
  // backgroundColor (not `background`) so this overrides Recharts' default white box.
  backgroundColor: "rgba(18,18,26,0.96)",
  border: "1px solid rgba(255,255,255,0.14)",
  borderRadius: 12,
  boxShadow: "0 12px 26px rgba(0,0,0,0.34)",
  color: "#ececf3",
} as const;

export const CHART_TOOLTIP_LABEL_STYLE = {
  color: "#ececf3",
} as const;

// Recharts paints each item with `entry.color || '#000'` and pie/bar payloads
// carry no colour, so it must be set explicitly here (itemStyle wins over that default).
export const CHART_TOOLTIP_ITEM_STYLE = {
  color: "#ececf3",
} as const;

/** Spread onto every Recharts `<Tooltip>` so hover pop-ups read the same everywhere. */
export const chartTooltipProps = {
  contentStyle: CHART_TOOLTIP_STYLE,
  labelStyle: CHART_TOOLTIP_LABEL_STYLE,
  itemStyle: CHART_TOOLTIP_ITEM_STYLE,
} as const;

/** Hover highlight for bar charts; Recharts' default is an opaque light grey block. */
export const CHART_BAR_CURSOR = { fill: "rgba(255,255,255,0.05)" } as const;

export const CHART_AXIS_TICK = { fill: "#b2b3c1", fontSize: 11 } as const;

/** Categorical palette for pies and per-category bars. */
export const PIE_COLORS = [
  "#06B6D4",
  "#22C55E",
  "#A855F7",
  "#F59E0B",
  "#E50914",
  "#38BDF8",
  "#FB7185",
  "#A3E635",
];

/**
 * Revenue and profit keep the same hues everywhere they appear, so the
 * Overview donut, the P&L bars and the portfolio graph agree on what
 * "revenue" looks like.
 */
export const SERIES_COLORS = {
  revenue: "#38BDF8",
  profit: "#22C55E",
  expense: "#E50914",
} as const;

/**
 * Projected is the same hue at low opacity, actual is the solid fill — the
 * wireframe's "light area = projected, shaded area = actual".
 */
export const PROJECTED_OPACITY = 0.28;

export function pieColor(index: number): string {
  return PIE_COLORS[index % PIE_COLORS.length];
}
